// R149 — extracted from DocumentsPage.jsx (632 lines → thin container).

export const VIS = [
  { value: "all", label: "Everyone", tone: "border-emerald-500/40 text-emerald-300" },
  { value: "residents", label: "Residents only", tone: "border-sky-500/40 text-sky-300" },
  { value: "board", label: "Board / directors", tone: "border-violet-500/40 text-violet-300" },
  { value: "admins", label: "Admins only", tone: "border-red-500/40 text-red-300" },
];

export const fmtBytes = (n) => {
  if (!n) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};
